import React from 'react';
import { dictionary } from '../../../../dictionary';

const ProductivityWorkPlaceCounter = (props) => {
  const properties = props.properties;
  const styles = props.resourcesStyles;
  const data = properties.monthlyData;
  const employeesTotal = properties.employees + properties.employees2;
  const homeOfficeSum = data.reduce((total, obj) => {
    if (obj.wpl === 'PZO/PZH' && obj.esp === '') {
      return total + obj.hours;
    }
    return total;
  }, 0);

  const officeSum = data.reduce((total, obj) => {
    if (obj.wpl === 'Biuro' && obj.esp === '') {
      return total + obj.hours;
    }
    return total;
  }, 0);

  const totalworkingHoursSum = Math.round(homeOfficeSum + officeSum);
  const totalworkingDays = Math.round(totalworkingHoursSum / 8);
  const homeOfficeDays = Math.round(homeOfficeSum / 8);
  const officeDays = Math.round(officeSum / 8);
  const homeOfficePercentage = totalworkingDays > 0 ? Math.round((homeOfficeDays / totalworkingDays) * 100) : 0;
  const officePercentage = totalworkingDays > 0 ? Math.round((officeDays / totalworkingDays) * 100) : 0;

  return (
    <>
      <tr>
        <th style={styles.darktd}>{dictionary.productivity_table_wpl_ho_hours}</th>
        <td style={styles.darktd}></td>
        <td style={styles.bluetd}>{homeOfficeSum}</td>
        <td style={styles.lighttd}>{homeOfficeDays + ' days'}</td>
        <td style={styles.darktd}>{homeOfficePercentage + '%'}</td>
      </tr>
      <tr>
        <th style={styles.darktd}>{dictionary.productivity_table_wpl_office_hours}</th>
        <td style={styles.darktd}></td>
        <td style={styles.bluetd}>{officeSum}</td>
        <td style={styles.lighttd}>{officeDays + ' days'}</td>
        <td style={styles.darktd}>{officePercentage + '%'}</td>
      </tr>
      <tr>
        <th style={styles.darktd}>{dictionary.productivity_table_wpl_total}</th>
        <td style={styles.darktd}></td>
        <td style={styles.bluetd}>{totalworkingHoursSum}</td>
        <td style={styles.lighttd}>{totalworkingDays + ' days'}</td>
        <td style={styles.darktd}>{homeOfficePercentage + officePercentage + '%'}</td>
      </tr>
    </>
  );
};

export default ProductivityWorkPlaceCounter;
